var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImage = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.95 2.25C3.45883 2.25 2.25 3.45883 2.25 4.95V19.05C2.25 20.5412 3.45883 21.75 4.95 21.75H19.05C20.5412 21.75 21.75 20.5412 21.75 19.05V4.95C21.75 3.45883 20.5412 2.25 19.05 2.25H4.95ZM4.5 3.75C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75H4.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.25 10.5C9.49264 10.5 10.5 9.49264 10.5 8.25C10.5 7.00736 9.49264 6 8.25 6C7.00736 6 6 7.00736 6 8.25C6 9.49264 7.00736 10.5 8.25 10.5ZM8.25 9C8.66421 9 9 8.66421 9 8.25C9 7.83579 8.66421 7.5 8.25 7.5C7.83579 7.5 7.5 7.83579 7.5 8.25C7.5 8.66421 7.83579 9 8.25 9Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1943 10.2921C15.9081 9.9927 15.4333 9.98205 15.1339 10.2683L3.75009 21.1527L5.25 21.75L15.6285 11.8708L20.6658 16.7866L21.7499 15.75L16.1943 10.2921Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image.24e95efa8b1ba3c7a2aca27882f7b36f.svg";